import { SharedValuePairInterface } from 'src/app/shared/models/shared/shared-value-pair.interface';
import { FilterGroupEnum } from 'src/app/store/shared-filters/models/filter-group.enum';
import { FilterEnum } from 'src/app/store/shared-filters/models/filter.enum';
import { ExtRfrOrdItemI, ExtRfrOrdSearchI } from './rfr-ord-search.result.ext';
import { RfrOrdSearchQueryI } from './rfr-ord-search.query.int';
import { ExtRfrOrdSearchQueryI } from './rfr-ord-search.query.ext';
import { RfrOrdSearchI } from './rfr-ord-search.result.int';
import { RfrOrdItemI } from './rfr-ord-item.int';
import { RfrOrdActionEnum } from './rfr-ord-action.enum';
import { RfrOrdHeatingTypeEnum } from './rfr-ord-heating-type.enum';

export const MapRfrOrdSearch = {
  mapQuery: (int: RfrOrdSearchQueryI): ExtRfrOrdSearchQueryI => {
    const filters = [];

    const reeferDisconnectedFilter = int.filterGroups?.find(filterGroup => filterGroup.key === FilterGroupEnum.rfrOrdDisconnected);
    if (reeferDisconnectedFilter?.value === FilterEnum.rfrOrdDisconnectedYes) {
        filters.push({
            field: 'all_disconnected',
            operator: 'eq',
            value: true,
        });
    }

    return {
      request: {
          filter: JSON.stringify({
              filter: {
                  logic: 'and',
                  filters: [
                      ...filters
                  ],
                  sort: [],
                  skip: 0,
                  top: 999,
              }
          })
      }
    };
  },
  mapResult: (ext: ExtRfrOrdSearchI): RfrOrdSearchI =>  {
     return {
      result: (ext.response?.dsdp_reefer_order?.tt_dp_reefer_order ?? []).map(extOrder => (
          MapRfrOrdSearch.mapOrder(extOrder))).sort((a, b) => a.index - b.index)
      }
  },
  mapOrder: (ext: ExtRfrOrdItemI): RfrOrdItemI => {
    return {
        seqNr: ext.seqnr,
        action: ext.calc_action as RfrOrdActionEnum,
        remainingMinutes: ext.calc_minutes_expire,
        containerNumber: ext.calc_containernumber,
        location: ext.location,
        inVessel: ext.in_vessel,
        outVessel: ext.out_vessel,
        customer: ext.customer_shortname,
        subCustomer: ext.subcustomer_shortname,
        cyclus: MapRfrOrdSearch.mapImportExport(ext.cycluscode),
        index: ext.calc_counter,
        goodsDescription: ext.des_goods,
        imo: ext.imocode,
        unnrs: ext.calc_unnrs,
        heatingTypeCode: ext.heating_typecode as RfrOrdHeatingTypeEnum,
        temperature: ext.temperature,
        temperatureMaxDevition: ext.temperature_max_deviation,
        estDateOfDeparture: ext.dt_etd,
    };
  },
  mapImportExport: (code: string): SharedValuePairInterface => {
    if (code) {
      if (code.toUpperCase() === 'I') {
        return {
          description: 'Import',
          value: 'I',
        };
      }
      if (code.toUpperCase() === 'E') {
        return {
          description: 'Export',
          value: 'E',
        };
      }
      if (code.toUpperCase() === 'S') {
        return {
          description: 'Storage',
          value: 'S',
        };
      }
      if (code.toUpperCase() === 'T') {
        return {
          description: 'Transhipment',
          value: 'T',
        };
      }
    }
  },
};